<app-auth-header></app-auth-header>

<div
  class="relative h-[100%] bg-cover bg-center text-white flex items-center justify-center "
  style="background-image: url('assets/images/home_bg_img.png')"
>
  <div class="absolute inset-0 bg-[#272c36] bg-opacity-60"></div>

  <div
    class="fixed z-10 flex justify-center w-[61.25vw] bg-[#F1F3F5] rounded-[8px] h-[71.2vh] "
  >
    <div class="w-[100%] h-[100%] m-[76px] ml-[20px] mr-[20px] mt-[1.5rem]">
      <div class="verification-container text-center mt-[1rem]">
        <h3 class="!text-[#21252A] !mb-2.5 !text-left !text-[24px] !font-bold">
        <mat-icon class="!text-[#21252A] pt-[3px] font-semibold cursor-pointer" (click)="navigateTo()">chevron_left</mat-icon>
          Verification
        </h3>
        <div class="flex justify-center mt-[34px]">
          <p class="text-[#21252A] text-[20px] Roboto font-medium leading-[24px]">
            Enter the 6-digit code sent to your email to confirm your
            subscription.<br />
            Please check your inbox and enter the code below to complete the
            process
          </p>
        </div>
        <form [formGroup]="verificationForm">
          <div
            class="input-group flex justify-center gap-[21px] text-[#203D54] mt-[41px]"
          >
            <ng-container *ngFor="let digit of otpArray; let i = index">
              <input
                #otpInput
                type="tel"
                maxlength="1"
                [formControlName]="'digit' + (i + 1)"
                class="digit-input w-12 h-12 text-center !bg-[#fdf0ec] text-24px border border-[#e9b3a0] rounded-sm shadow-[0px_2px_2px_0px_rgba(231,107,63,0.20)]"
                (input)="
                  onKey(
                    $event,
                    otpInputs.toArray()[i + 1],
                    otpInputs.toArray()[i - 1]
                  )
                "
              />
            </ng-container>
          </div>
          <div class="mt-[10px]">
            <div *ngIf="successOtpMessage" class="error-message text-green-600 mt-2">
              {{ successOtpMessage }}
            </div>
          <div *ngIf="invalidOtpMessage" class="error-message text-red-500 mt-2">
            {{ invalidOtpMessage }}
          </div>
          <span *ngIf="isFadeOut && !isHidden" class="text-[#868E96]" id="countdownDisplay">
            Resend code will be available in {{ countdown }} s
          </span>
          
        </div>
          <button
            class="mt-[26px] w-[6.5625rem] h-[3rem] !rounded-[5px] verify-button bg-[#E76B3F] text-[16px] font-semibold text-[#F1F3F5] cursor-pointer"
            [class.bg-[#E76B3F]]="!isSendingOtp"
            [class.bg-gray-400]="isSendingOtp"
            [class.cursor-not-allowed]="isSendingOtp"
            [disabled]="isSendingOtp"
            type="button"
            (click)="verifyOtp()"
          >
            {{ isSendingOtp ? "Verifying..." : "Verify" }}
          </button>
          <div class="ml-[90px] mt-[1rem]">
            <a
              (click)="resendCode()"
              class="text-[18px] text-[#2368A2] !font-medium cursor-pointer"
              style=" float: left"
              >Send a new Code</a
            >
          </div>
        </form>

        <div class="flex justify-start items-center" *ngIf="isShowOtpMessage">
          <div
            class="flex justify-center items-center mt-[40px] verify-otp-message"
            [ngClass]="{ 'fade-out': isFadeOut }"
            >
            <img
              class="rounded-full mr-[10px]"
              src="assets/icons/verify-otp-success.svg"
              alt="verify otp icon"
            />
            <p class="verify-message">
              Verification code has been resent to your email
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
